import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Categories, ICategoriestRedux } from '../../../../../interfaces/src/lib/interfaces/index';
import { CabinCategoryDataProps } from '../../../../../interfaces/src/lib/types/index';

const initialState: ICategoriestRedux = {
  categories: null,
  secondCategories: null,
  cfFilteredCategories: null,
  allCategories: null,
  allCategoriesWithCFData: [],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state: ICategoriestRedux, action: PayloadAction<Categories[]>) => {
      state.categories = action.payload;
    },
    setSecondCategories: (state: ICategoriestRedux, action: PayloadAction<Categories[]>) => {
      state.secondCategories = action.payload;
    },
    setAllCategories: (state: ICategoriestRedux, action: PayloadAction<Categories[]>) => {
      state.allCategories = action.payload;
    },
    setCFfilteredCategories: (
      state: ICategoriestRedux,
      action: PayloadAction<CabinCategoryDataProps[]>
    ) => {
      state.cfFilteredCategories = action.payload;
    },
    setAllCategoriesWithCFData: (
      state: ICategoriestRedux,
      action: PayloadAction<CabinCategoryDataProps[]>
    ) => {
      state.allCategoriesWithCFData = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase('resetFromPriceType', (state) => {
        state.categories = initialState.categories;
        state.cfFilteredCategories = initialState.cfFilteredCategories;
        return state;
      })
      .addCase('resetFromOccupancy', () => {
        return initialState;
      })
      .addCase('resetFromCabinType', () => {
        return initialState;
      }),
});

export const {
  setCategories,
  setSecondCategories,
  setCFfilteredCategories,
  setAllCategories,
  setAllCategoriesWithCFData,
} = categoriesSlice.actions;
export default categoriesSlice.reducer;
